import React from 'react'
import BoothList from '../../components/booth/BoothList'

export default function BoothListPage() {
  return (
    <div>
      <BoothList/>
    </div>
  )
}
